import FileUploader from '@hotmart/file-uploader';
import { fetcher } from 'src/config/request';
import { UploadEndpoints } from './endpoints';
function getUploadConfig({ entityType, subdomain, productId, accessToken }) {
    return {
        config: {
            type: entityType,
            url: UploadEndpoints.getUploadConfig()
        },
        subdomain,
        accessToken,
        system: 'club_admin',
        authParams: { 'x-product-id': productId.toString() }
    };
}
export const UploadService = {
    uploadFile({ file, productId, entityType, accessToken, subdomain, onProgress }) {
        const config = getUploadConfig({ entityType, productId, accessToken, subdomain });
        return new Promise((resolve, reject) => {
            function handleSuccess(data) {
                resolve(data.id);
            }
            function handleFailure(error) {
                reject(error);
            }
            function handleProgress(data) {
                onProgress?.(data.progress);
            }
            FileUploader.setCallbackSuccess(handleSuccess)
                .setCallbackFailure(handleFailure)
                .setCallbackProgress(handleProgress)
                .build(config, false)
                .then((uploader) => {
                return uploader.send(file, {
                    metaData: {
                        subdomain
                    }
                });
            })
                .catch(handleFailure);
        });
    },
    getPreviewUrl(file) {
        return new Promise((resolve) => {
            const fileReader = new FileReader();
            fileReader.addEventListener('load', () => {
                resolve(fileReader.result);
            });
            fileReader.readAsDataURL(file);
        });
    },
    async getFilesByEntityType(entityId, entityType) {
        const response = await fetcher.get(UploadEndpoints.getFilesByEntityType(entityId, entityType));
        return response.data.sort((a, b) => a.fileOrder - b.fileOrder);
    },
    async getUploadConfig(type) {
        const response = await fetcher.get(UploadEndpoints.getUploadConfig(), {
            params: { type }
        });
        return response.data;
    }
};
